export default "__VITE_ASSET__WfLBh8ny__"